import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48119785324714:1';
  return <section className="py-16 px-4 bg-gray-900 text-white text-center" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <div className="text-2xl md:text-3xl font-bold mb-12 space-y-6 leading-relaxed" data-id="element-74">
          <p data-id="element-75">
            El detailing profesional puede ser
            <br data-id="element-76" /> más simple de lo que creés.
          </p>
          <p data-id="element-77">
            No necesitás más videos de YouTube.
            <br data-id="element-78" /> Necesitás un sistema que te sostenga
            <br data-id="element-79" /> en cada servicio, todo el año.
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} text="👉 Accedé ahora al MegaPack" subtext="★ MegaPack Detailer Argentino ★" className="mb-16" data-id="element-80" />

        <footer className="pt-8 border-t border-gray-800 text-gray-500 text-sm font-medium" data-id="element-81">
          <p className="mb-2" data-id="element-82">
            © 2025 MegaPack Detailer Argentino. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-4" data-id="element-83">
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-84">
              Privacidad
            </a>
            <span data-id="element-85">·</span>
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-86">
              Términos y Condiciones
            </a>
          </div>
        </footer>
      </div>
    </section>;
}